import React, { Component, Dispatch } from 'react';
import { FilterInitialValues, PollingQrState } from '../../../models/pages/pollingQr';
import Translator from '../../../core/i18n';
import { Common } from '../../../core/common';
import { Collapse } from 'reactstrap';
import imgAnn from '../../../static/images/empty-polling-qr.svg';
import StudentList from '../../table/student-list';
import { IAction, IAppState } from '../../../models/action/core';
import { connect } from 'react-redux';
import moment from 'moment';
import AddActivityTabs from '../../add-activity/tabs';
import { Formik, FormikProps } from 'formik';
import { Modal } from 'reactstrap';
import { getValidation } from '../../../models/validations/activity-document-validation';
import Loading from '../../loading/loading';
import SelectClasses from '../../add-activity/select-classes';
import { ActivityType } from '../../../models/enums/ActivityType';
import { IAddPollingQr } from '../../../models/components/add-qr-polling';
import { IFilters, IQrPollingData } from '../../../models/action/qrPolling';
import CAddActivityFooter from '../../add-activity/footer';
import { Confirm } from '../../notification/main';
import * as Actions from '../../../store/actions/qrPolling';
import CQrPollingReportTable from './polling-report-table/main';
import { EQrPollingStatusType } from '../../../models/components/qrPolling';
import { Log } from 'ng2-logger';


const T = Translator.create();
let _common: Common;
const _logger = Log.create('lesson-polling-qr-main.tsx');

const spinnerId = 'addQrPollingLoading';

class PollingQr extends Component<IAddPollingQr, PollingQrState> {
    private intervalId: NodeJS.Timeout | null = null;
    private attendanceIntervalId: NodeJS.Timeout | null = null;

    constructor(props: IAddPollingQr) {
        super(props);
        _common = new Common();
        this.closeQrCode = this.closeQrCode.bind(this);
        this.clearQrCodeInterval = this.clearQrCodeInterval.bind(this);
        this.validateTabAndChange = this.validateTabAndChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            currentTab: '_selectClassTab',
            validations: {},
            qrCodeValue: null,
            isCollapseOpen: false,
            isBlurred: false,
            isModalOpen: false,
            filters: Object.assign({}, FilterInitialValues),
            studentListType: null,
            selectedClassIds: [],
            isQrCodeModal: false
        };
    }

    componentDidMount() {
        this.props.dispatch(Actions.GetActiveAttendance(this.props.coursePageClassId ?? "-1", this.onTrigger))
        this.getAttendanceList(1);
    }

    getAttendanceList(page: number) {
        const { take, orderBy } = this.props.AttendanceListData.filters || {}
        this.props.dispatch(Actions.GetAttendancesList(this.props.coursePageClassId ?? "-1", page, "", take ?? 10, orderBy ?? "", 'getAttendancesList', 'get'));
    }

    componentWillUnmount() {
        this.clearQrCodeInterval();
    }

    qrCodeInterval = () => {
        this.clearQrCodeInterval();
        this.intervalId = setInterval(() => {
            this.generateQrCode()
        }, 10000);
    };

    closeQrCode = () => {
        this.props.dispatch(Actions.EndAttendance(this.props.coursePageActivityId!, this.props.AttendanceData.attendanceGuid, () => {
            this.props.dispatch(Actions.SetGenerateQrCode(null));
            this.setState({ isBlurred: false, studentListType: null })
            this.clearQrCodeInterval();
        }))

    };

    clearQrCodeInterval = () => {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    };

    validateTabAndChange = async (values: FormikProps<any>, onClickNext: boolean, nextTab?: string, completeForm?: boolean) => {
        this.createQrCodeForAttendance()
    };

    selectedClassIds = (selectedClassIds: any) => {
        const value = JSON.parse(selectedClassIds).map((item: any) => item.value);
        if (JSON.stringify(this.state.selectedClassIds) !== JSON.stringify(value)) {
            this.setState({ selectedClassIds: value });
        }
    };

    createQrCodeForAttendance = () => {
        this.props.dispatch(Actions.CreateQrCodeForAttendance(this.props.coursePageClassId ?? "-1", this.state.selectedClassIds, this.props.coursePageActivityId ?? "0", this.onTrigger, 'CreateQrCodeForAttendance', 'get'));
    }

    onTrigger = () => {
        this.generateQrCode()
        this.getAttendanceStudentList(1)
    }

    generateQrCode = () => {
        this.props.dispatch(Actions.GenerateQrCode(this.props.coursePageClassId ?? "-1", this.props.AttendanceData.attendanceGuid ?? "0", this.onCloseModal, 'GenerateQrCode', 'get'));
    }

    getAttendanceStudentList = (page: number) => {
        const filters: IFilters = {
            Take: 10,
            Page: page,
            OrderBy: "",
            Query: ""
        }
        this.props.dispatch(Actions.GetAttendanceStudentsList(this.props.coursePageClassId ?? "-1", this.props.AttendanceData.attendanceId ?? "0", this.props.AttendanceData.attendanceGuid ?? "0", this.props.AttendanceData.attendanceExpirationDate, this.state.studentListType, filters, 'getAttendanceStudentsList', 'get'));
    }

    onCloseModal = () => {
        this.setState({ isModalOpen: false }, () => {
            this.qrCodeInterval()
        })
    }

    onQrModalClose = () => {
        this.setState({ isQrCodeModal: false })
    }

    getClassess = () => {
        this.props.dispatch(Actions.GetClassess(this.props.coursePageActivityId ?? "-1", this.checkUserClasses));
    }


    checkUserClasses = () => {
        const { results } = this.props.Classess;
        if (results.length === 1) {
            const selectedClassId = results[0].value;
            this.setState({ selectedClassIds: [selectedClassId] }, this.createQrCodeForAttendance);
        } else {
            this.isModalControl();
        }
    }


    isModalControl = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen })
    }


    onSubmit = (FormikValues: IQrPollingData) => {
        this.createQrCodeForAttendance()
    };

    public deletePollingOnConfirm = () => {
        Confirm.setConfirm('twoOption', this.closeQrCode, T.t('r_attendance_quit_confirm_message'), null, null, undefined, undefined, undefined, T.t('r_yes'), T.t('r_no'));
    };

    toggleActive = (type: any) => {
        this.setState({ studentListType: type }, () => {
            this.props.AttendanceUserListData.filters.page = 1;
            this.getAttendanceStudentList(this.props.AttendanceUserListData.filters.page);
        });
    };

    gradeInformation = () => {

        const { joinedStudentCount, notJoinedStudentCount, totalStudentCount } = this.props.AttendanceCounts
        let joinedProgress = Math.floor((joinedStudentCount * 100) / totalStudentCount);
        let notJoinedProgress = Math.floor((notJoinedStudentCount * 100) / totalStudentCount);

        return (
            <div className="qr-polling-counter-blocks grid-2 gap-1">
                <button className={`qr-polling-grade-info ${this.state.studentListType == null && 'active'}`} onClick={() => this.toggleActive(null)}>
                    <div className="media-body">

                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className='mt-1'>{totalStudentCount ?? 0}</h4>
                        </div>
                        <div className='d-flex justify-content-between align-items-center'>
                            <span>{T.t('r_polling_total_count')}</span>
                            <input checked={this.state.studentListType === null} type="radio" className='assignment-grade-radio-button' />
                        </div>
                    </div>
                </button>

                <button className={`qr-polling-grade-info ${this.state.studentListType == EQrPollingStatusType.Joined && 'active'}`} onClick={() => this.toggleActive(0)}>
                    <div className="media-body" style={{ backgroundColor: 'blue !important' }}>
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className='mt-1'>{joinedStudentCount ?? 0}</h4>
                            <i className="qr-polling-counter-blocks-progress">
                                {joinedStudentCount ? joinedProgress >= 100 ? '%100' : '%' + joinedProgress : 0}
                            </i>
                        </div>
                        <div className='d-flex justify-content-between align-items-center'>
                            <span>{T.t('r_polling_participants')}</span>
                            <input checked={this.state.studentListType === 0} type="radio" className='assignment-grade-radio-button' />
                        </div>
                    </div>
                </button>

                <button className={`qr-polling-grade-info ${this.state.studentListType === EQrPollingStatusType.NotJoined && 'active'}`} onClick={() => this.toggleActive(1)}>
                    <div className="media-body">
                        <div>
                            <div className='d-flex justify-content-between align-items-center'>
                                <h4 className='mt-1'>{notJoinedStudentCount ?? 0}</h4>
                                <i className="qr-polling-counter-blocks-progress">
                                    {notJoinedStudentCount ? notJoinedProgress >= 100 ? '%100' : '%' + notJoinedProgress : 0}
                                </i>
                            </div>
                            <div className='d-flex justify-content-between align-items-center'>
                                <span>{T.t('r_polling_not_participants')}</span>
                                <input checked={this.state.studentListType === 1} type="radio" className='assignment-grade-radio-button' />
                            </div>
                        </div>
                    </div>
                </button>
            </div>
        )
    }

    render() {
        const { isCollapseOpen, isBlurred } = this.state;
        const { QrCodeValue, AttendanceListData, AttendanceUserListData } = this.props
        const initialFormValues = {
            ...this.props.pollingData!,
        }

        return (
            <>
                {/* <div className="row d-flex justify-content-center align-items-center" style={{ margin: '10px 5px', cursor: 'pointer' }}>
                    <div className="process-card">
                        <div className="process-row-image d-flex justify-content-center align-items-center" style={{ backgroundColor: '#39b27b'}} >
                            <i className="material-icons" style={{ color: '#EEE',
                                        fontSize: "36px" }}>
                                qr_code_2
                            </i>
                        </div>
                        <div className="list-content d-inline-block process-card-container">
                            <h5 className="mt-0 mb-0 text-center" style={{ marginBottom: 2.5 }}>
                                {T.t('r_polling_by_qr_main_title')}
                            </h5>
                            <p className='process-card-description-wrap'>{T.t('r_polling_by_qr_explain')}</p>
                        </div>
                    </div>
                </div> */}
                <Collapse isOpen={isCollapseOpen} >

                    {(!QrCodeValue && AttendanceListData && AttendanceListData?.results?.length > 0) &&
                        <CQrPollingReportTable
                            results={AttendanceListData.results}
                            filters={AttendanceListData.filters}
                            onChange={(e: number) => this.getAttendanceList(e)}
                            onModalChange={() => this.getClassess}
                        />
                    }

                    {(!QrCodeValue && !AttendanceListData.results) && (
                        <div className='d-flex flex-column align-items-center justify-content-center'>
                            <img src={imgAnn} alt="Announcement" />
                            <span className='mt-4 text-center'>
                                <b>{T.t('r_qr_polling_empty_data')}</b>
                            </span>
                            <span className='text-center'>
                                {T.t('r_polling_message')}
                            </span>
                            <button className='qr-code-tag-square tag-green mt-2 mb-3' onClick={this.getClassess}>
                                <i className="material-icons mr-2">add</i>
                                {T.t('r_create_qr_code')}
                            </button>
                        </div>
                    )}

                    {QrCodeValue && (
                        <div className='d-flex flex-column align-items-center justify-content-center'>
                            <div className='polling-qr-code-info'>
                                <i className="material-icons mr-2">info</i>
                                <p>{T.t('r_qr_polling_info')}</p>
                            </div>
                            <div className='grid-23 gap-5 mt-4 mb-4'>
                                <div>
                                    <img className={`${isBlurred && "blurred-qr-code"}`} style={{ width: "100%" }} src={`data:image/png;base64,${QrCodeValue}`} alt="QR Code" />
                                </div>
                                <div className='d-flex flex-column justify-content-center'>
                                    {this.gradeInformation()}
                                    <div className='d-flex align-items-center justify-content-center' >
                                        <button className='qr-code-tag-square tag-danger' onClick={this.deletePollingOnConfirm}>
                                            <i className="material-icons mr-2">close</i>
                                            {T.t('r_end_polling')}
                                        </button>
                                        <button className={`qr-code-tag-square tag-${isBlurred ? "info" : "gray"} mx-3`} onClick={() => this.setState({ isBlurred: !this.state.isBlurred })}>
                                            <i className="material-icons mr-2">{isBlurred ? "play_arrow" : "pause"}</i>
                                            {isBlurred ? T.t('r_keep_polling') : T.t('r_pause_polling')}
                                        </button>
                                        <button className='qr-code-tag-square tag-gray' onClick={() => this.setState({ isQrCodeModal: true })}>
                                            <i className="material-icons mr-2">zoom_in</i>
                                            {T.t('r_enlarge_qr_code')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {AttendanceUserListData.results.length > 0
                                ?
                                <StudentList
                                    currentTab={this.state.currentTab}
                                    results={AttendanceUserListData.results}
                                    filters={AttendanceUserListData.filters}
                                    onChange={(e: number) => this.getAttendanceStudentList(e)}
                                    studentListType = {this.state.studentListType}
                                />
                                :
                                <div className='qr-student-list-empty d-flex flex-column align-items-center justify-content-center'>
                                    <img src={imgAnn} alt="Announcement" />
                                    <span className='mt-4 text-center'>
                                        <b>{this.state.studentListType === 0 ? T.t('r_attendance_no_participant_yet') : T.t('r_all_students_participated_in_attendance')}</b>
                                    </span>
                                    <span className='text-center'>
                                        {this.state.studentListType === 0 ? T.t('r_attendance_no_participant_yet_explain') : T.t('r_all_students_participated_in_attendance_explain')}
                                    </span>
                                </div>
                            }
                        </div>
                    )}
                </Collapse>

                <Modal
                    isOpen={this.state.isModalOpen}
                    toggle={this.isModalControl}
                    modalClassName={'add-activity-modal modal-from-right slideInRight show animated'}
                    fade={true}
                    style={{ display: 'block', animationDuration: '0.5s' }}
                    backdrop={'static'}
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <Formik validationSchema={getValidation} initialValues={initialFormValues} onSubmit={this.onSubmit}>
                                {props => {
                                    return (
                                        <form onSubmit={props.handleSubmit} role="form">
                                            <div className="modal-header">
                                                <h5 className="modal-title d-flex align-items-center">
                                                    <i className="material-icons mr-2">{_common.GetMaterialActivityIcons(ActivityType.Document)}</i>
                                                    <span>{T.t('r_polling_by_qr')}</span>
                                                </h5>
                                                <button
                                                    onClick={this.isModalControl}
                                                    type="button"
                                                    className="close"
                                                    data-dismiss="modal"
                                                    aria-label="Close"
                                                >
                                                    <i style={{ color: '#000' }} className="material-icons">
                                                        close
                                                    </i>
                                                    <span>{T.t('r_gen_close')}</span>
                                                </button>
                                            </div>
                                            <div className="modal-body p-0">

                                                <AddActivityTabs
                                                    currentTab={this.state.currentTab}
                                                    formikProps={""}
                                                    validateTabAndChange={this.validateTabAndChange}
                                                    isProjectSubActivity={true}
                                                    isSingleClass={true}
                                                    hasClass = {true}
                                                />
                                                <div className="tab-content" id="tabContent">
                                                    <SelectClasses
                                                        coursePageActivityId={this.props.coursePageActivityId!}
                                                        currentTab={this.state.currentTab}
                                                        isUpdate={this.props.updateActivityId}
                                                        selectedClassIds={this.selectedClassIds}
                                                    />
                                                </div>

                                            </div>
                                            <CAddActivityFooter
                                                currentTab={this.state.currentTab}
                                                formikProps={props}
                                                spinnerId={spinnerId}
                                                validateTabAndChange={this.validateTabAndChange}
                                                isProjectSubActivity={this.props.isProjectSubActivity}
                                                setCloseModal={this.isModalControl}
                                            />
                                        </form>
                                    );
                                }}
                            </Formik>
                        </div>
                    </div>
                </Modal>

                <Modal
                    className="pt-0"
                    style={{ maxWidth: '40vw' }}
                    isOpen={this.state.isQrCodeModal}
                    toggle={this.onQrModalClose}
                    fade={true}
                    backdrop={'static'}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Qr Kod
                            </h5>
                            <button
                                onClick={this.onQrModalClose}
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                style={{marginInlineEnd: "0px"}}
                            >
                                <i style={{ color: '#000' }} className="material-icons">
                                    close
                                </i>
                            </button>
                        </div>
                        <div className="modal-body" style={{ padding: 0, background: 'rgb(251, 250, 246)' }}>
                            <div className="container-fluid p-0">
                                <img className={`${isBlurred && "blurred-qr-code active-modal"}`} style={{ width: "100%" }} src={`data:image/png;base64,${QrCodeValue}`} alt="QR Code" />
                            </div>
                        </div>
                        <div className="modal-footer d-block">

                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAddPollingQr): IAddPollingQr => {
    if (!state) {
        return ownProps;
    }

    const newProps: IAddPollingQr = Object.assign({}, ownProps, {
        pollingData: state.qrPolling.PollingData,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        AttendanceData: state.qrPolling.AttendanceData,
        AttendanceCounts: state.qrPolling.AttendanceCounts,
        AttendanceListData: state.qrPolling.AttendanceListData,
        AttendanceUserListData: state.qrPolling.AttendanceUserListData,
        Classess: state.qrPolling.Classess,
        QrCodeValue: state.qrPolling.QrCodeValue,
        filters: state.coursePage.assignmentGradeStudentList ? state.coursePage.assignmentGradeStudentList.filters : {},
        results: state.coursePage.assignmentGradeStudentList ? state.coursePage.assignmentGradeStudentList.results : [],
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
    next.qrPolling.PollingData === prev.qrPolling.PollingData &&
    next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
    next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
    next.qrPolling.AttendanceData === prev.qrPolling.AttendanceData &&
    next.qrPolling.AttendanceCounts === prev.qrPolling.AttendanceCounts &&
    next.qrPolling.AttendanceListData === prev.qrPolling.AttendanceListData &&
    next.qrPolling.Classess === prev.qrPolling.Classess &&
    next.qrPolling.QrCodeValue === prev.qrPolling.QrCodeValue &&
    next.coursePage.assignmentGradeStudentList === prev.coursePage.assignmentGradeStudentList;

    return ret;
};


const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CPollingQr = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(PollingQr);

export default CPollingQr;
